import React, { useContext } from "react";
import { Container, Row, Col, Button } from "react-bootstrap";
import "./SupplementBanner.css";
import WhiteButton from "./../../common_components/common_button/WhiteButton";
import { useNavigate } from "react-router-dom";
import { getProduct } from "../../../features/admin/product/productdetails/Slice";
import { useDispatch, useSelector } from "react-redux";
import { useEffect } from "react";
import { IDS } from "../../../utils/IDS";
import { Context } from "../../../utils/context";
import Cookies from "js-cookie";

export default function SupplementBanner() {
  const dispatch = useDispatch();

  const { userdata } = useContext(Context);

  const productsdetails = useSelector((state) => state.product.productdetails);

  const products = productsdetails?.products;
  const productdetail = productsdetails?.products?.productdetails;

  var HtmlToReactParser = require("html-to-react").Parser;
  var htmlToReactParser = new HtmlToReactParser();

  useEffect(() => {
    dispatch(getProduct());
  }, [dispatch]);
  const navigate = useNavigate();

  // const handleKnowMore = () => {
  //   Cookies.remove("shippingData");
  //   Cookies.remove("orderData");

  //   navigate("/cart");
  // };
  return (
    <section className="supplement-banner">
      <img
        src="images\home\Mask Group 11.png"
        alt=""
        className="side-image side-image-left"
      />

      <img
        src="images\home\Mask Group 12.png"
        alt=""
        className="side-image side-image-right"
      />
      <Container>
        <div className="banner-card">
          <Row className="align-items-center">
            {/* Left Image */}
            <Col lg={6} md={6} className="text-center  productImage">
              <img
                // src="/images/home/supplement_banner/product.png"
                src={`${IDS.IMG_URL}${products?.image}`}
                alt="Spirulina Supplement"
                className="banner-image"
              />
            </Col>

            {/* Right Content */}
            <Col lg={6} md={6}>
              <div className="banner-content">
                {/* <h2>Spirulina Superfood Supplement</h2> */}
                <h2>{products?.name}</h2>
                <p>
                  {/* Pure Nutrition For Everyday Wellness */}
                  {htmlToReactParser.parse(products?.description)}
                </p>

                <h3 className="price">₹ {products?.price}/-</h3>
                {/* {userdata?.order?.length === 0 ? ( */}
                <WhiteButton
                  title={"Know More"}
                  bg="#F35F37"
                  color="#ffff"
                  hoverColor="#ffff"
                  hoverBg={"#000"}
                  className="price-btn"
                  onClick={() => navigate("/products")}
                />
                {/* ) : (
                  <p className="already-purchased-text">
                    You have already purchased this product.
                  </p>
                )} */}
              </div>
            </Col>
          </Row>
        </div>
      </Container>
    </section>
  );
}
